import React from 'react';
import { SocialIcon } from 'react-social-icons';

const Sidebar = () => {
  return (
    <div className="sidebar">
      <SocialIcon url="https://www.facebook.com/imhackx?mibextid=ZbWKwL" style={{ marginRight: '10px' }} />
      <SocialIcon url="https://www.linkedin.com" style={{ marginRight: '10px' }} />
      <SocialIcon url="https://www.instagram.com/hackx_uok?igsh=MWJudzl0c3NjOGJ2ag==" style={{ marginRight: '10px' }} />
      <SocialIcon url="https://youtube.com/@hackxuok?si=mmNGnlwlnagdLKPU" style={{ marginRight: '10px' }} />
      {/* Add more SocialIcon components with different URLs as needed */}
    </div>
  );
};

export default Sidebar;
